<h1>Очереди</h1>

<div class="material-datatable-wrapper">
  <app-datatable-headline
    [global_search_string]="global_search_string"
    [items_per_page_vars]="items_per_page_vars"
    (items_per_page_change)="itemPerPageChange($event)"
    (global_search_change)="onGlobalSearch($event)">
  </app-datatable-headline>
  <div class="table-responsive">
    <table class="table table-striped datatable table-rwd">
      <thead app-data-table-head
             [sort]="sort"
             [columns]="columns"
             (sort_emmit)="onSortChange($event)">
      </thead>
      <tbody app-data-table-body
             (rowClick)="rowClick.emit($event)"
             [columns]="columns">
      </tbody>
    </table>
  </div>
  <app-datatable-pagination
    [current_page]="current_page"
    (change_page)="changePage($event)">
  </app-datatable-pagination>
</div>

<ng-template #priceTmpl let-row="row">
  <div [innerHtml]="row.realty_flat_price"></div>
</ng-template>

<ng-template #priceAgdTmpl let-row="row">
  <div [innerHtml]="row.realty_flat_object_agv"></div>
</ng-template>

<ng-template #priceSubTmpl let-row="row">
  <div [innerHtml]="row.realty_flat_object_sub"></div>
</ng-template>
